import React from 'react';
import { T, NUMERIC } from './orders.theme';
import { COPY } from './orders.copy';

/**
 * Reports an order's state. It never changes it — that is the toggle at the
 * far right of the row.
 *
 * The four kinds are a partition: an invoice order is never also paid or
 * pending, which is what lets the filter chips add up to the whole list.
 */
const KINDS = {
  paid: { bg: T.paidTint, dot: T.paid, ink: T.paid, label: COPY.paid },
  pending: { bg: T.pendingTint, dot: T.pending, ink: T.pendingInk, label: COPY.pending },
  invoice: { bg: T.brandTint, dot: T.brand, ink: T.brandInk, label: COPY.invoice },
  canceled: { bg: T.canceledTint, dot: T.canceled, ink: T.inkSoft, label: COPY.canceled },
};

export function kindOf(entry) {
  if (entry.isCanceled) return 'canceled';
  if (entry.isInvoice) return 'invoice';
  return entry.isPending ? 'pending' : 'paid';
}

export default function OrderStatusPill({ kind, onTinted = false }) {
  const spec = KINDS[kind] || KINDS.paid;

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 6,
        // On a tinted row the pill's own tint disappears, so it goes white.
        background: onTinted ? T.surface : spec.bg,
        borderRadius: T.radiusPill,
        padding: '4px 9px',
        width: 'fit-content',
        ...NUMERIC,
      }}
    >
      <span
        style={{
          width: 6,
          height: 6,
          borderRadius: T.radiusPill,
          background: spec.dot,
          flexShrink: 0,
        }}
      />
      <span style={{ fontSize: 11, fontWeight: 700, color: spec.ink, whiteSpace: 'nowrap' }}>
        {spec.label}
      </span>
    </span>
  );
}

/** Three dots, used while a write is in flight. */
export function PulsingDots({ color = T.surface }) {
  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {[1, 0.6, 0.3].map((opacity, i) => (
        <span
          key={i}
          style={{
            width: 5,
            height: 5,
            borderRadius: T.radiusPill,
            background: color,
            opacity,
          }}
        />
      ))}
    </span>
  );
}
